
/**
 * 
 * @param {Number | String} n - text/number will be padded
 * @param {Number} l - padded text length
 * @param {String} c - added string 
 * @param {Boolean} r - add text to left-hand-side
 * @param {Boolean} b 
 * @returns 
 * e.g pad(1, 4, '0') -> 0001
 */
const pad = (n, l, c, r, b) => {
    var s = n.toString(),
        l = l || 2,
        r = r !== false,
        b = b !== false;
    if (s.length > 0) {
        var p = "";
        if (!isNaN(n) && s.charAt(0) == "-") {
            p = "-";
            s = s.substring(1);
        }
        while (s.length < l) {
            if (r) s = (c || "0") + s;
            else s += c || "0";
        }
        return b ? p + s : s;
    } else { return "" };
}

/**
 * e.g separator(1000) -> 1,000 
 */
const separator = (n, c, l) => {
    if (n === undefined || n === null) return '';
    var l = l || 3;
    var r = new RegExp("\\B(?=(\\d{" + l + "})+(?!\\d))", "g");
    var p = n.toString().split(".");
    p[0] = p[0].replace(r, c || ",");
    return p.join(".");
}

/**
 * 
 * @param {Number} number 
 * @param {Number} decPlace - 取小數點後幾多個位
 * @returns Number
 */
const round = (number = 0, decPlace = 1) => {
    const multiplier = Math.pow(10, decPlace || 0);
    return Math.round(parseFloat(number) * multiplier) / multiplier;
}
const roundUp = (number, decPlace = 1) => {
    const multiplier = Math.pow(10, decPlace || 0);
    return Math.ceil(parseFloat(number) * multiplier) / multiplier;
}
const formatMoney = (number) => {
    return roundUp(number);
}

// =============== Date related ===============
/**
 * @param {*} d - new Date()
 * @returns String - YYYY-MM-DD
 */
const formatDate = (d = new Date(), time = false) => {
    if (typeof d.getFullYear === 'function') {
        let s = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        if (time) {
            s += `T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}Z`;
        }

        return s;
    }
    return '';
}

/**
* @param {String} d - YYYY-MM-DD | [YYYY-MM-DD]T[HH:MM:SS]
* @returns Number - weekday number
*/
const getDay = (d) => {
    if (!d) return -1;
    const date = convertDate(d);
    return date.getDay();
}

const convertDate = (date = '', time = '') => {
    let d = null;

    let t = '';
    if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
        t = time;
    } else if (/^\d{2}:\d{2}$/.test(time)) {
        t = `${time}:00`;
    }
    if (date) {
        if (!t) {
            t = '12:00:00';
        }

        const year = parseInt(date.substring(0, 4));
        const month = parseInt(date.substring(5, 7)) - 1;
        const dayDate = parseInt(date.substring(8, 10));
        const hour = parseInt(t.substring(0, 2));
        const minute = parseInt(t.substring(3, 5));
        const second = parseInt(t.substring(6, 8));
        d = new Date(year, month, dayDate, hour, minute, second);

    } else {
        d = new Date();
        if (t) {
            const hour = parseInt(t.substring(0, 2));
            const minute = parseInt(t.substring(3, 5));
            const second = parseInt(t.substring(6, 8));
            d.setHours(hour);
            d.setMinutes(minute);
            d.setSeconds(second);
        }
    }
    return d;
}

const sortDate = (a, b) => {
    const { date: aDate, time: aTime } = _splitDatetime(a);
    const { date: bDate, time: bTime } = _splitDatetime(b);
    const aDateObj = convertDate(aDate, aTime);
    const bDateObj = convertDate(bDate, bTime);
    return aDateObj.getTime() - bDateObj.getTime();
}

const _splitDatetime = (d) => {
    let obj = {
        date: '',
        time: ''
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(d) || /^\d{4}\/\d{2}\/\d{2}$/.test(d)) {
        obj.date = d;
    } else if (/([0-9]{4}-[0-9]{2}-[0-9]{2})(T[0-9]{2}:[0-9.]+(:[0-9.]+)?)?Z?/) {
        obj.date = d.substring(0, 10);
        obj.time = d.substring(11, 19);
    }
    return obj;
}

export default {
    formatDate,
    formatMoney,
    getDay,
    pad,
    round,
    roundUp,
    separator,
    convertDate,
    sortDate
}